import React, { SetStateAction, useEffect, useState } from 'react';
import { jsonAxios } from 'components/axios';
import { ReactComponent as Close } from 'assets/header/close.svg'
import { IGroupTrackingInfo } from 'types/transport';
import { ReactComponent as Plane } from 'assets/transport/detail/plane.svg'
import { airStatus } from 'data/transport';

interface ITransportTracking {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    info: IInfo
}

interface IInfo {
    type: string,
    bookingNumber: string
    blNo: string
    carrierName: string
}

const TransportTracking = ({ isOpen, setIsOpen, info }: ITransportTracking) => {
    const [userToken, setUserToken] = useState<string>('');
    const [url, setUrl] = useState<string>('');
    const [list, setList] = useState<IGroupTrackingInfo[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (info.type === 'SEA' && info.blNo) {
            getToken()
            const blNo = info.blNo.toUpperCase();
            setUrl(`mblNo=${blNo}`);
        }
        else {
            // detailInfo?.detailInfo.trackingInfo &&
            //     detailInfo?.detailInfo.trackingInfo.length > 0 ?
            //     setList(groupByStation(detailInfo?.detailInfo.trackingInfo)) :
            //     setList([])
        }
    }, [info.blNo])

    const close = () => {
        setIsLoading(true)
        setIsOpen(false)
    }

    const getToken = () => {
        jsonAxios.post('tokens').then(res => {
            if (res.data.code === 200) {
                setUserToken(res.data.data)
            }
        })
    }

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="relative bg-white shadow-lg rounded-lg w-[1200px] tablet:w-full">
                    <div className='flex justify-between items-center px-4 border-[#F8F8FA] border-b-2 h-15 shrink-0'>
                        <p className='font-semibold tablet:text-lg text-2xl'>운송현황</p>
                        <Close
                            className='w-5 h-5 cursor-pointer'
                            onClick={() => close()}
                        />
                    </div>
                    <div className='h-[80vh] overflow-y-auto font-semibold text-center'>

                        <div className='flex flex-col gap-10 tablet:gap-4 h-full'>
                            {/* <div className='flex flex-wrap gap-10 tablet:gap-4 font-semibold tablet:text-lg text-2xl text-left'>
                                <div className='tablet:w-full min-w-[240px]'>
                                    <p>{info.type === 'SEA' ? 'BL' : 'MAWB'}</p>
                                    <div className='bg-[#F8F8F8] px-6 py-4.5 rounded font-medium tablet:text-base text-lg'>
                                        {info.blNo}
                                    </div>
                                </div>
                                <div className='tablet:w-full min-w-[240px]'>
                                    <p>부킹번호</p>
                                    <div className='bg-[#F8F8F8] px-6 py-4.5 rounded font-medium tablet:text-base text-lg'>
                                        {info.bookingNumber}
                                    </div>
                                </div>
                                <div className='tablet:w-full min-w-[240px]'>
                                    <p>{info.type === 'SEA' ? '선사명' : '항공사명'}</p>
                                    <div className='bg-[#F8F8F8] px-6 py-4.5 rounded font-medium tablet:text-base text-lg'>
                                        {info.carrierName}
                                    </div>
                                </div>
                            </div> */}
                            {
                                info.type === 'SEA' ?
                                    userToken && url && (
                                        <div className="relative flex-1 w-full">
                                            {isLoading && (
                                                <div className="z-10 absolute flex justify-center items-center bg-white w-full">
                                                    <p className="text-black">해상트래킹 불러오는 중...</p>
                                                </div>
                                            )}
                                            <iframe
                                                title="Tracking Information"
                                                src={`https://insight.seavantage.com/cargo/tracking?userToken=${userToken}&${url}`}
                                                className="w-full h-full"
                                                onLoad={() => {
                                                    setIsLoading(false)
                                                }}
                                            />
                                        </div>
                                    ) :
                                    <div className='flex flex-col gap-3 w-full'>
                                        {
                                            list.map((item, idx) => (
                                                <div className='flex items-start' key={idx}>
                                                    <div className='w-[122px]'>
                                                        <div className={`flex items-center text-2xl tablet:text-lg text-white px-4 rounded font-semibold h-20 ${idx === 0 ? 'bg-primary' : 'bg-[#9D9EB7]'}`}>{item.station}</div>
                                                        <div className='flex items-center gap-2'>
                                                            <Plane />
                                                            <p className='font-semibold text-lg'>{item.flight_number}</p>
                                                        </div>
                                                    </div>
                                                    <div className='flex flex-col flex-1 gap-3'>
                                                        {
                                                            item.list.map((items, index) => {
                                                                const matched = airStatus.find(arr => arr.code === items.status);
                                                                const Icon = (idx === 0 && index === 0) ? matched?.IconOn : matched?.IconOff;
                                                                return (
                                                                    <div className='flex justify-between items-center shadow-[0px_0px_4px_rgba(0,0,0,0.1)] rounded h-20 text-base' key={index}>
                                                                        <div className='flex flex-[2.0] items-center gap-3 px-6'>
                                                                            <div className='w-10 shrink-0'>
                                                                                {Icon && <Icon />}
                                                                            </div>
                                                                            <p>{airStatus.find(arr => arr.code === items.status)?.name}({items.status})</p>
                                                                        </div>

                                                                        <div className='flex-[1.5]'>
                                                                            <p>{items.actual_date}</p>
                                                                        </div>

                                                                        <div className='flex flex-col flex-[1.0] px-6 leading-none'>
                                                                            <p className='text-[#9D9EB7] text-sm'>무게</p>
                                                                            <p>{items.weight ? `${items.weight}kg` : '-'}</p>
                                                                        </div>

                                                                        <div className='flex flex-col flex-[1.0] px-6 leading-none'>
                                                                            <p className='text-[#9D9EB7] text-sm'>화물갯수</p>
                                                                            <p>{items.piece ?? '-'}</p>
                                                                        </div>

                                                                        <div className='flex flex-col flex-[2.0] px-6 leading-none'>
                                                                            <p className='text-[#9D9EB7] text-sm'>이벤트</p>
                                                                            <p>{items.event}</p>
                                                                        </div>

                                                                        <div className='flex flex-col flex-[2.5] px-6 leading-none'>
                                                                            <p className='text-[#9D9EB7] text-sm'>비고</p>
                                                                            <p>{airStatus.find(arr => arr.code === items.status)?.description}</p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransportTracking;